import { render, staticRenderFns } from "./PostItemContextMenu.vue?vue&type=template&id=46b3012a&"
import script from "./PostItemContextMenu.vue?vue&type=script&lang=js&"
export * from "./PostItemContextMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports